import React, { useState } from "react";
import { saveAs } from "file-saver";
import {
  fetchEmployeeImage,
  fetchOrgImage,
  fetchImagesAsBase64FromServer,
  fetchRespImagesAsBase64FromServer,
} from "../annexture/imageUtils";
import "../../.csscode/ExportPrint.css";
import GenericModal from "../GenericModal";
import buildInspectionDocx from "./InspectionWordReport";
import buildAuditDocx from "./AuditWordReport";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export default function ExportWordFromPrint(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // "I" = Inspection report (default), "A" = Audit report
  const mode = props.mode || "I";
  const isAudit = mode === "A";
  const reportLabel = isAudit ? "Audit" : "Inspection";

  const handleSelect = (type) => {
    setModalOpen(false);
    handleExport(type);
  };

  const handleExport = async (type) => {
    setIsLoading(true);

    try {
      // Only keep annexures that are actually used
      const allAnnexures = props.annextureList || [];
      const propsDetails = props.details || [];

      const usedAnnexureIds = new Set(
        propsDetails.filter((i) => i.annexure).map((i) => i.annexure),
      );

      const annextureList = allAnnexures.filter((a) =>
        usedAnnexureIds.has(a.value),
      );

      // Same parameters for both builders
      const reportParams = {
        ...props,
        isQuestion: type === "with", // true = with questions, false = without
        annextureList,
        fetchImagesAsBase64FromServer,
        fetchRespImagesAsBase64FromServer,
        fetchEmployeeImage,
        fetchOrgImage,
      };

      const blob = isAudit
        ? await buildAuditDocx(reportParams)
        : await buildInspectionDocx(reportParams);

      const factory = props.auddetails?.name || "factory";
      const name = `${props.scheduleid || "schedule"}-${factory}-${reportLabel.toLowerCase()}_report.docx`;

      saveAs(blob, name);
    } catch (err) {
      console.error("Export to Word failed:", err);
      alert("Failed to export DOCX.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="word-btn"
        disabled={
          props.noSchedule || props.isBodyLoading || props.loading || isLoading
        }
        onClick={() => setModalOpen(true)}
        title="Export to Word"
      >
        <DescriptionOutlinedIcon />
        {isLoading ? "Generating..." : "Export to Word"}
      </button>

      <GenericModal
        open={modalOpen}
        title="Choose Report Type"
        message={`Do you want the ${reportLabel} Word Report with questions or without questions?`}
        onSelect={handleSelect}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}
